import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "answerType",
    "fixedPanel",
    "entityBlock",
    "optionsBlock",
    "fixedBlock",
    "showOnFrontpageBlock",
    "membersHint"
  ]

  connect() {
    this.syncAll()
  }

  syncAll() {
    this.syncFixedPanels()
    this.syncTypeChrome()
  }

  syncFixedPanels() {
    if (!this.hasAnswerTypeTarget) return

    const v = this.answerTypeTarget.value
    this.fixedPanelTargets.forEach((el) => {
      const match = el.dataset.answerType === v
      el.classList.toggle("d-none", !match)
      el.querySelectorAll("input, select, textarea").forEach((field) => {
        if (!field.name) return
        field.disabled = !match
      })
    })
  }

  syncTypeChrome() {
    if (!this.hasAnswerTypeTarget) return

    const v = this.answerTypeTarget.value
    const entity = v === "questionnaire_entity"
    const options = v === "options" || v === "checkboxes"
    const members = v === "members"
    const fixedSupported = ["text", "options", "checkboxes", "boolean", "date"].includes(v)

    if (this.hasEntityBlockTarget) this.toggleBlock(this.entityBlockTarget, entity)
    if (this.hasOptionsBlockTarget) this.toggleBlock(this.optionsBlockTarget, options)
    if (this.hasFixedBlockTarget) this.toggleBlock(this.fixedBlockTarget, fixedSupported)
    if (this.hasShowOnFrontpageBlockTarget) this.toggleBlock(this.showOnFrontpageBlockTarget, true)

    if (this.hasMembersHintTarget) {
      this.membersHintTarget.classList.toggle("d-none", !members)
    }
  }

  toggleBlock(el, visible) {
    el.classList.toggle("d-none", !visible)
    el.querySelectorAll("input, select, textarea").forEach((field) => {
      if (!field.name) return
      field.disabled = !visible
    })
  }
}

